export default "__VITE_ASSET__CBOixpJT__"